import {action} from 'mobx';
import {DomainStore} from 'shared/store';

class InterviewScheduleDirectoryState {
  store = new DomainStore();
  history;

  constructor(history) {
    this.history = history;
  }

  @action async deleteInterviewSchedule(model) {
    await this.store.destroy(model);
  }
}

export default InterviewScheduleDirectoryState;
